import { types } from "mobx-state-tree";

export const PermissionsUserModel = types.array(
  types.model({ id: types.identifier, title: types.string, description: types.string })
);
